import { DateTime } from 'luxon';
import { transformTimeRangeToDurations } from 'utils/timeRangeMagic';

import { DTEP2dTableState } from '../types';

const mergeTemplateAndData = (state: DTEP2dTableState): DTEP2dTableState => {
    const { datasets, viewblockState, time, capabilities } = state;

    const { settings, databilities } = viewblockState;

    if (!datasets || datasets.length === 0 || databilities.length === 0 || !time || capabilities.length === 0) {
        return state;
    }

    const datasetIds = databilities.map(({ datasetId }) => datasetId);
    const capabilityIds = databilities.map(({ capabilityId }) => capabilityId);
    const filteredDatasets = datasets.filter((dataset) => {
        return !dataset.error && !!dataset.datasetId && datasetIds.includes(dataset.datasetId) && capabilityIds.includes(dataset.capabilityId!);
    });

    if (filteredDatasets.length === 0) {
        return state;
    }

    const { timeRange } = settings;
    const { start, end } = transformTimeRangeToDurations(timeRange);
    const startTime = DateTime.utc().setZone(time.timezone).startOf('day').plus(start);
    const endTime = DateTime.utc().setZone(time.timezone).startOf('day').plus(end);

    const rows = filteredDatasets.map((filteredDataset) => {
        // TODO handle when cfjson is not defined (error from getData)
        const datums = filteredDataset.cfjson!.variables[Object.keys(filteredDataset.capability!.variables)[0]].data as string[];
        const rowDateTimes = datums
            .map((dateTimeISO) => DateTime.fromISO(dateTimeISO).setLocale(settings.timeLocale).setZone(time.timezone))
            .filter((datetime) => {
                return datetime.startOf('day') >= startTime && datetime.startOf('day') <= endTime;
            });
        const rowValues = rowDateTimes.map((rowDateTime) => rowDateTime.toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }));

        const databilityIndex = databilities.findIndex(({ id }) => id === filteredDataset.databilityId);

        return {
            label: settings.labelDatabilities[databilityIndex] || filteredDataset.capability!.display_name_short,
            rowDateTimes,
            rowValues,
        };
    });
    const columns = rows[0].rowDateTimes;
    // const columns = rows[0].rowDateTimes.map((rowDateTime) => rowDateTime.toFormat('ccc d LLL'));
    const offsetLeft = !!state.viewblockState.settings.useFixedOffset && typeof settings.offsetLeft !== 'undefined' ? settings.offsetLeft : undefined;

    return {
        ...state,
        model: {
            timezone: time.timezone,
            fontSize: state.viewblockState.settings.fontSize,
            columns,
            offsetLeft,
            rows,
            displayTableHeading: state.viewblockState.settings.displayTableHeading,
        },
    };
};

export default mergeTemplateAndData;
